import React,{useState} from 'react'
import { Footer, Navbar } from "../components";
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import configData from "../config.json";
import { useSelector } from 'react-redux'

const Register = () => {
    const [inputData,setInputData]=useState({regName:'',regEmail:'',password:'',conPassword:''});
    const navigate=useNavigate();
    const state = useSelector(state => state.handleCart);
    const [error, setError] = useState('');

  const handleInput=(e)=>{
    const {name,value}=e.target; 
    setInputData({...inputData,[name]:value}); 

    if(e.target.name==='password'){
        if(e.target.value !== inputData.conPassword){setError('Password not matches')} else setError('');
    } else if(e.target.name==='conPassword'){
        if(inputData.password !== e.target.value){setError('Password not matches')} else setError('');
    }
  }

  const handleSubmit=async(e)=>{
    e.preventDefault();
    const allinputData={regName:inputData.regName,regEmail:inputData.regEmail,password:inputData.password}
    
    if(!error){
    let res=await axios.post(configData.SERVER_URL+'/registrationEntry',allinputData);
    if(res.status===200){
        console.log(res.data);
        if(res.data===1){
            setTimeout(()=>{
                if(state.length>0){
                    navigate('/checkout');
                } else{navigate('/register');}   
              },2000)
              alert('Registration Complete');
        }else{
            alert('Email already Registered');
        }
      
    } else{
      alert('Registration Fail');
    }  
    }
  }

    return (
        <>
            <Navbar />
            <div className="container my-3 py-3">
                <h1 className="text-center">Register</h1>
                <hr />
                <div class="row my-4 h-100">
                    <div className="col-md-4 col-lg-4 col-sm-8 mx-auto">
                        <form onSubmit={handleSubmit}>
                            <div class="form my-3">
                                <label for="Name">Full Name</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="regName"
                                    name='regName'
                                    value={inputData.regName} onChange={(e)=>{handleInput(e)}}
                                    placeholder="Enter Your Name"
                                    required
                                />
                            </div>
                            <div class="form my-3">
                                <label for="Email">Email address</label>
                                <input
                                    type="email"
                                    class="form-control"
                                    id="regEmail"
                                    name='regEmail'
                                    value={inputData.regEmail} onChange={(e)=>{handleInput(e)}}
                                    placeholder="name@example.com"
                                    required
                                />
                            </div>
                            <div class="form  my-3">
                                <label for="Password">Password</label>
                                <input
                                    type="password"
                                    class="form-control"
                                    id="password"
                                    name='password'
                                    value={inputData.password} onChange={(e)=>{handleInput(e)}}
                                    placeholder="Password"
                                    required
                                />
                            </div>

                            <div class="form  my-3">
                                <label for="Password">Confirm Password</label>
                                <input
                                    type="password"
                                    class="form-control"
                                    id="conPassword"
                                    name='conPassword'
                                    value={inputData.conPassword} onChange={(e)=>{handleInput(e)}}
                                    placeholder="Confirm Password"
                                    required
                                />
                                <p style={{color:'red'}}>{error}</p>
                            </div>
                            {/* <div className="my-3">
                                <p>Already has an account? <Link to="/login" className="text-decoration-underline text-info">Login</Link> </p>
                            </div> */}
                            <div className="text-center">
                                <button class="my-2 mx-auto btn btn-dark" type="submit">
                                    Register
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Register